import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRateIndexRateOptionsPanel extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelRateOptions: Label;
    labelRateTypes: Label;
    panelRateOptions: Panel;
    sourceRateIndexControl: DataSource;
    switchAutoRateRetreival: Switch;
    switchBilledRates: Switch;
    switchContractRates: Switch;
    switchDisplaySpotRates: Switch;
    switchInternalRates: Switch;
    switchUseMarketRateFuelSurcharge: Switch;
    textboxCustomerId: Textbox;
    textboxGenerateRate: Textbox;
    textboxRateRequest: Textbox;
    textboxTrailerType: Textbox;
}
